import { render, staticRenderFns } from "./bindAccount.vue?vue&type=template&id=be8ce4e6&scoped=true&"
import script from "./bindAccount.vue?vue&type=script&lang=js&"
export * from "./bindAccount.vue?vue&type=script&lang=js&"
import style0 from "./bindAccount.vue?vue&type=style&index=0&id=be8ce4e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8ce4e6",
  null
  
)

export default component.exports